define('app/sds/service/attributes/sds-service-attributes',["service!sds-service-attributes"], function (serviceAttributesService) {
	return {
		controller: {
			bind: {
				"service": "=",
				"attributes": "=?"
			},
			prototype: {
				loadAttributes: function loadAttributes() {
					var vm = this;
					vm.loadingAttributes = serviceAttributesService(vm.service.Id)
						.then(function $then(attributes) {
							vm.failedLoad = false;
							vm.attributes = attributes;
						}, function $catch(err) {
							vm.failedLoad = true;
						});
				}
			},
			constructor: ["$self", "$watch", function (vm, $watch) {
				vm.loadAttributes();
			}]
		}
	};
});
